import axios from 'axios';
import { domain } from './domain'

export const createRequest = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
        data
    }
    return axios(`${domain}/request`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}

export const validateRequest = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
        data
    }
    return axios(`${domain}/request/validate`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}